import {
	Button, ButtonAppearance, ButtonColor, SwitchInput,
	SwitchSize,
} from '@aleph/shared-components';
import useSupergridSettings from 'wb-spotify/app/routes/superGrid/hooks/useSupergridSettings';

function ToggleLifetimeStats() {
	const { lifetimeStats, toggleLifetimeStats } = useSupergridSettings();

	return (
		<Button
			className="flex flex-row items-center gap-2"
			onClick={toggleLifetimeStats}
			title="Lifetime Stats"
			rightNode={
				<div className="w-[32px]">
					<SwitchInput
						checked={lifetimeStats}
						size={SwitchSize.SMALL}
					/>
				</div>
			}
			appearance={ButtonAppearance.GHOST}
			active={lifetimeStats}
			color={ButtonColor.GRAY}
		/>
	);
}

export default ToggleLifetimeStats;
